// @ts-check
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import sunglassesDudesImg from 'images/characters/sunglasses-dudes.svg';
import Icon from 'components/base/Icon';
import { editCustomPmMetricsModalOptions } from 'modals/modal-options-factory';
import { useDispatch } from 'react-redux';
import { LBButton } from '@linearb/buzz';

const EmptyStateCustomPmWidget = ({
  toggleModal,
  widget,
  issueTypes,
  isEmptyStateMetric,
  onSave
}) => {
  const dispatch = useDispatch();

  if (isEmptyStateMetric) {
    return null;
  }
  return (
    <Flex items='center' direction='column' margin='auto'>
      <img src={sunglassesDudesImg} alt='' />
      <br />
      <Text size='x-x-large'>No issues yet</Text>
      <br />
      <Text size='large'>
        <b>Click the gear icon to configure</b>
      </Text>
      <Flex mt='medium'>
        <LBButton
          variant='outline'
          size='icon'
          onClick={() => {
            toggleModal(
              editCustomPmMetricsModalOptions({
                widget,
                issueTypes,
                onChange: onSave
              })
            )(dispatch);
          }}
        >
          <Icon size='normal' name='settings' alpha={0.7} />
        </LBButton>
      </Flex>
    </Flex>
  );
};
export default EmptyStateCustomPmWidget;
